export default __webpack_public_path__ + "static/media/icon-geliefert.31a74711.svg";